import React, {Component, ReactElement, ReactNode} from 'react'
import NatMessageRepo from '../message/repository/NatMessageRepo'
import {MessageInfo, NatGetMessageList, SearchCondition} from '../message/repository/NatGetMessageList'
import {
    APPLY_CATEGORY,
    HAVE_OR_NOT,
    LOGIN_MODE,
    NOTIFICATION_DO_OR_NOT,
    RESIDENT_APPLY_STATUS,
    ROLE_FOR_RESIDENT_REAL,
} from '../../../CodeMaster'
import {HKConstants} from '../../../HKConstants'
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo'
import {CurrentDateTime, NatGetCurrentDateTime} from '../currentDateTime/repository/NatGetCurrentDateTime'
import {judgeAuthorityCheck, judgeHaveAnyOneOfAuthorities, NatAsyncCallFunction} from '../../common/util/Natutil'
import NatResidentUserRepo from '../residentUser/repository/NatResidentUserRepo'
import {NatGetResidentUserAuthed} from '../residentUser/repository/NatGetResidentUserAuthed'
import {SortOrder} from '../../../components/shared/SortOrder'
import {COMMON_CONSTANTS} from '../../../CommonConstants'
import {ContentsMainTitleBorder, MainContainer, TxtBold} from '../../../styledComponents/ContentsArea'
import {Box} from '@mui/material'
import {formatForDateInput} from '../../../formatters/formatDate'
import {StyledDiv, StyledImg, StyledLi, StyledUl} from '../../../styledComponents/StyledTypeDefinitions'
import styled, {css} from 'styled-components'
import {generateMedia} from 'styled-media-query'
import {BreakPoint, Colors, FontSize, FontWeights} from '../../../styledComponents/Constants'
import {SecondaryButton} from '../../../styledComponents/Button'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {Nullable} from '../../../app/TypeHelpers'
import {SmallPlainLink, UnstyledLink} from '../../../styledComponents/Links'
import AuthorityChecker from '../../../components/AuthorityChecker'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import ReservationsRepository from '../../../components/reservations/ReservationsRepository'
import {ReservationStatusCardInformation} from '../../../components/reservations/AdditionalChargeCardInformation'
import ReservationCardInformation from '../../../components/reservations/ReservationCardInformation'
import NatFacilityReserveRepo from '../facilityReserve/repository/NatFacilityReserveRepo'
import {MeetingRepositoryForResident} from '../../../components/assocDirector/MeetingRepositoryForResident'
import MeetingSimple from '../../../components/assocDirector/model/MeetingSimple'
import moment, {Moment} from 'moment'
import {ResidentLoginInfoSessionStorageKey} from '../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import {BlockSpacer} from '../../../styledComponents/ResponsiveConvenience'
import {BlueInfoIcon} from '../../../components/assocDirector/AssocDirectorCommon'
import NatRegistrationDialogComponent from '../common/resident/NatRegistrationDialogComponent'
import {ApplyHistoryInfo, NatGetApplyHistoryList} from '../applications/repository/NatGetApplyHistoryList'
import {NatApplicationRepo} from '../applications/repository/NatApplicationRepo'
import {convertApplyStatusIntoApplyHistoryDivision} from '../applications/common/helper/NatApplicationHelper'
import {NatGetSmileagePoint, NatGetSmileagePointResponseBean} from '../residentUser/repository/NatGetSmileagePoint'
import NatSmileagePointComponent from './NatSmileagePointComponent'
import NatSutekiNetPlusRepo from '../mypage/repository/NatSutekiNetPlusRepo'
import {NatGetSutekiNetPlus} from './repository/NatGetSutekiNetPlus'
import {NatResidentMessageListItemComponent} from '../message/NatResidentMessageListPage'
import NatCampaignRepo from '../campaigns/repository/NatCampainRepo'
import {NatCampaingInfos, NatGetCampaign} from '../campaigns/repository/NatGetCampaign'
import MessageDialogComponent from '../../../common/resident/MessageDialogComponent'
import {Messages} from '../../../Messages'
import {Location} from 'react-router-dom'
import NatAmountFixRepo from '../AmountFix/repository/NatAmountFixRepo';
import {NatGetBillingAmountFixInfo} from '../AmountFix/repository/NatGetBillingAmountFixInfo';
import {NatGetResidentUserInvolvingSub} from '../residentUser/repository/NatGetResidentUserInvolvingSub';
import NatSutekiNetPlusComponent from './NatSutekiNetPlusComponent';
import ResidentGeneralMeetingRepo, {
    GetUnitOwnershipByLoginUserResponse,
    ResidentGeneralMeetingInfo
} from '../../../components/generalMeeting/ResidentGeneralMeetingRepo'

const KEY_LOGIN_MODE: string = 'loginMode'
const KEY_SELECTED_CONDOMINIUM_CD: string = 'selectedCondominiumCd'
const KEY_SELECTED_RIDGE_CD: string = 'selectedRidgeCd'
const KEY_SELECTED_ROOM_NUMBER: string = 'selectedRoomNumber'
const KEY_USER_ID: string = 'userId'
const KEY_SELECTED_CONDOMINIUM_NAME: string = 'selectedCondominiumName'
const KEY_SELECTED_CONDOMINIUM_IMAGE: string = 'selectedCondominiumImage'
const KEY_SELECTED_CONDOMINIUM_ZIP_CODE: string = 'selectedCondominiumZipCode'
const KEY_SELECTED_CONDOMINIUM_ADDRESS_PREFECTURE: string = 'selectedCondominiumAddressPrefecture'
const KEY_SELECTED_CONDOMINIUM_ADDRESS_ADDRESS2: string = 'selectedCondominiumAddressAddress2'
const KEY_SELECTED_CONDOMINIUM_ADDRESS_ADDRESS3: string = 'selectedCondominiumAddressAddress3'
const KEY_HOME_MILEAGE_LINK_GUIDE_DISPLAY_FLAG: string = 'homeMileageLinkGuideDisplayedFlag'


interface Props {
    residentUserRepo: NatResidentUserRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    messageRepo: NatMessageRepo,
    reservationsRepo: ReservationsRepository,
    applicationRepo: NatApplicationRepo,
    facilityReserveRepo: NatFacilityReserveRepo,
    meetingRepo: MeetingRepositoryForResident,
    campaignRepo: NatCampaignRepo,
    amountFixRepo: NatAmountFixRepo,
    residentGeneralMeetingRepo: ResidentGeneralMeetingRepo
    location: Location,
    sutekiNetPlusRepo: NatSutekiNetPlusRepo,
}

interface States {
    messageList: MessageInfo[]
    applyHistoryList: ApplyHistoryInfo[]
    waitingFlag: boolean
    facilityReserveConfirmLimit: string
    reservationCardInformations: ReservationStatusCardInformation[]
    reserveNoneFlag: boolean
    currentDateTime: CurrentDateTime
    userReservationListLinkTxt: string
    homeMileageLinkGuideDisplay: string
    apartViewFlag: boolean
    assocViewFlag: boolean
    applyStatusViewFlag: boolean
    condominiumuImagePath: Nullable<string>
    notNotifiedAmountFixYearMonth?: string
    residentGeneralMeetingInfoList: ResidentGeneralMeetingInfo[]
    dialogOpen: boolean
    isLoadCompleted: boolean
    showMeetingAttention: boolean
    showMeetingNeedsAttendanceReplyAttention: boolean
    showBeforeOccupancyMessage: boolean
    getSmileagePointResponse: NatGetSmileagePointResponseBean
    campaignInfo: NatCampaingInfos
    loginMode: Nullable<string>
    openOperationNotAvailableToAdminDialog: boolean
    sutekiNetPlusUrlPc: string
    sutekiNetPlusUrlSp: string
}

class NatResidentMypagePage extends Component<Props & ResidentPagePropsSet, States> {

    constructor(props: Props & ResidentPagePropsSet) {
        super(props)

        const condominiumuImagePath: Nullable<string> =
            SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_CONDOMINIUM_IMAGE)

        const roleId = SessionStorageHelper.getStringItemOrNull(ResidentLoginInfoSessionStorageKey.ROLE)

        this.state = {
            messageList: [],
            applyHistoryList: [],
            waitingFlag: false,
            facilityReserveConfirmLimit: '',
            reservationCardInformations: [],
            reserveNoneFlag: false,
            currentDateTime: {
                currentDateTime: '',
                holidayFlag: '',
            },
            userReservationListLinkTxt: '',
            homeMileageLinkGuideDisplay: NOTIFICATION_DO_OR_NOT.DO_NOT_NOTIFY.value,
            apartViewFlag: false,
            assocViewFlag: false,
            applyStatusViewFlag: false,
            condominiumuImagePath: condominiumuImagePath,
            residentGeneralMeetingInfoList: [],
            dialogOpen: false,
            isLoadCompleted: false,
            showMeetingAttention: false,
            showMeetingNeedsAttendanceReplyAttention: false,
            showBeforeOccupancyMessage: roleId === ROLE_FOR_RESIDENT_REAL.BEFORE_OCCUPANCY.value,
            getSmileagePointResponse: {
                showSmileagePointArea: false,
                showSmileagePoint: false,
                smileagePoint: null,
                expiringSmileagePoint: null,
                expiryDate: null,
            },
            loginMode: null,
            campaignInfo: {
                campaignUrl: '',
                campaignImagePath: '',
            },
            openOperationNotAvailableToAdminDialog: false,
            sutekiNetPlusUrlPc: '',
            sutekiNetPlusUrlSp: '',
        }
        this.handleCancelSetting = this.handleCancelSetting.bind(this)
        this.handleBackButtonClick = this.handleBackButtonClick.bind(this)
        this.handleHistoryBackButtonClick = this.handleHistoryBackButtonClick.bind(this)
        this.handleReserveListButtonClick = this.handleReserveListButtonClick.bind(this)
        this.onClickMessage = this.onClickMessage.bind(this)
        this.onClickBanner = this.onClickBanner.bind(this)
    }

    async componentDidMount(): Promise<void> {
        const searchCondition: SearchCondition = {}
        const condominiumCd: Nullable<string> = SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_CONDOMINIUM_CD)
        let searchConditionDate: Nullable<string> = ''

        await this.props.eventEmitter.showLoading()

        try {
            // 住まいレージポイント取得
            // APIの処理時間が長いので最初に通信の呼び出しを行い、他の通信が終了後に通信を待ち、住まいレージポイントの処理を行う
            const smileagePointPromise: Promise<Nullable<NatGetSmileagePoint>> =
                NatAsyncCallFunction(
                    this.props.residentUserRepo.getSmileagePoint.bind(
                        this.props.residentUserRepo), this.props.navigate)

            const loginMode: Nullable<string> =
                SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_MODE)

            if (loginMode === LOGIN_MODE.RESIDENT.value) {
                const homeMileageLinkGuideDisplayedFlag: Nullable<string> =
                    SessionStorageHelper.getStringItemOrNull(KEY_HOME_MILEAGE_LINK_GUIDE_DISPLAY_FLAG)

                // ユーザ情報取得
                if (homeMileageLinkGuideDisplayedFlag === null) {
                    const retResidentUser: Nullable<NatGetResidentUserAuthed> =
                        await NatAsyncCallFunction(
                            this.props.residentUserRepo.getResidentUserLogined.bind(
                                this.props.residentUserRepo), this.props.navigate)

                    if (retResidentUser && retResidentUser.details !== null) {
                        if (retResidentUser.details.smileageAvailability === HAVE_OR_NOT.HAVE.value &&
                            retResidentUser.details.accessControlDiv === HAVE_OR_NOT.NOT.value) {
                            this.setState({dialogOpen: true})
                        }
                        SessionStorageHelper.setItem(KEY_HOME_MILEAGE_LINK_GUIDE_DISPLAY_FLAG, '1')
                    }
                }
            }

            // 現在日時取得
            const currentDateTime: Nullable<NatGetCurrentDateTime> = await NatAsyncCallFunction(
                this.props.currentDateTimeRepo.getCurrentDateTime.bind(
                    this.props.currentDateTimeRepo), this.props.navigate)
            let currentDatetimeMoment: Nullable<Moment> = null

            if (currentDateTime && currentDateTime.details !== null) {
                this.setState({currentDateTime: currentDateTime.details})
                searchCondition.extractStart = formatForDateInput(`${currentDateTime.details.currentDateTime}+09:00`)
                searchCondition.extractEnd = formatForDateInput(`${currentDateTime.details.currentDateTime}+09:00`)
                currentDatetimeMoment = moment(currentDateTime.details.currentDateTime)
            }

            // 現在日から3か月前の日付を取得
            if (currentDatetimeMoment) {
                searchConditionDate = currentDatetimeMoment.clone().add(-3, 'month').format('YYYY-MM-DD')
            }

            // "本日は理事会があります"、"理事会の出欠回答依頼が届いています"メッセージの表示判定
            if (condominiumCd &&
                currentDatetimeMoment &&
                judgeAuthorityCheck(HKConstants.CMN.AUTH.VIEW_ASSOC_DIRECTOR)
            ) {
                const meetings: Nullable<MeetingSimple[]> = await NatAsyncCallFunction(
                    this.props.meetingRepo.getMeetings.bind(
                        this.props.meetingRepo,
                        condominiumCd,
                    ), this.props.navigate)
                if (meetings) {
                    const showMeetingAttention = meetings.some(meeting => {
                        let meetingStartDatetime: Moment
                        if (meeting.startTime !== null) {
                            meetingStartDatetime = moment(`${meeting.date} ${meeting.startTime}`)
                        } else {
                            meetingStartDatetime = moment(`${meeting.date}`).startOf('day')
                        }
                        let meetingEndDatetime: Moment
                        if (meeting.endTime !== null) {
                            meetingEndDatetime = moment(`${meeting.date} ${meeting.endTime}`)
                        } else {
                            meetingEndDatetime = moment(`${meeting.date}`).endOf('day')
                        }
                        return currentDatetimeMoment &&
                            (currentDatetimeMoment.isSame(meetingStartDatetime, 'day')
                                || currentDatetimeMoment.isSame(meetingEndDatetime, 'day')) &&
                            currentDatetimeMoment.isBefore(meetingEndDatetime)
                    })
                    this.setState({showMeetingAttention})
                }

                const meetingsNeedsAttendanceReply: Nullable<MeetingSimple[]> = await NatAsyncCallFunction(
                    this.props.meetingRepo.getMeetingsNeedsAttendanceReply.bind(
                        this.props.meetingRepo,
                        condominiumCd,
                    ), this.props.navigate)
                if (meetingsNeedsAttendanceReply) {
                    const showMeetingNeedsAttendanceReplyAttention = meetingsNeedsAttendanceReply.some(meeting => {
                        return currentDatetimeMoment && meeting.attendanceReplyDeadline &&
                            currentDatetimeMoment.isSameOrBefore(meeting.attendanceReplyDeadline, 'day')
                    })
                    this.setState({showMeetingNeedsAttendanceReplyAttention})
                }
            }
            // 請求額確定通知取得
            if (condominiumCd) {
                const billingInfo = await this.getNotifiedAmountFix(condominiumCd);
                if (billingInfo?.details) {
                    this.setState({notNotifiedAmountFixYearMonth: billingInfo.details.fixYearMonth})
                }
            }
            // 意思表明状況取得
            if (condominiumCd && judgeAuthorityCheck(HKConstants.CMN.AUTH.VIEW_GENERAL_MEETING)) {
                // 区分所有者確認
                let isUnitOwner = false
                if (judgeAuthorityCheck(HKConstants.CMN.AUTH.EDIT_UNIT_OWNER_CONFIRMATION)) {
                    const getUnitOwnershipByLoginUserResponse: Nullable<GetUnitOwnershipByLoginUserResponse>
                        = await NatAsyncCallFunction(
                        this.props.residentGeneralMeetingRepo.getUnitOwnershipByLoginUser.bind(
                            this.props.residentGeneralMeetingRepo
                        ),
                        this.props.navigate,
                    )
                    if (getUnitOwnershipByLoginUserResponse) {
                        isUnitOwner = getUnitOwnershipByLoginUserResponse.details === HAVE_OR_NOT.HAVE
                    }
                }
                // 総会一覧を取得
                if (isUnitOwner || loginMode === LOGIN_MODE.ADMIN.value) {
                    const residentGeneralMeetingInfoListResponse = await NatAsyncCallFunction(
                        this.props.residentGeneralMeetingRepo.getResidentGeneralMeetingInfoList.bind(
                            this.props.residentGeneralMeetingRepo,
                            condominiumCd,
                            false,
                            true,
                        ),
                        this.props.navigate,
                    )
                    if (residentGeneralMeetingInfoListResponse !== null
                        && residentGeneralMeetingInfoListResponse.details !== null) {
                        this.setState({
                            residentGeneralMeetingInfoList: residentGeneralMeetingInfoListResponse.details,
                        })
                    }
                }
            }
            // メッセージ取得
            const messageList: Nullable<NatGetMessageList> =
                await NatAsyncCallFunction(
                    this.props.messageRepo.getMessageList.bind(
                        this.props.messageRepo,
                        searchCondition,
                        {
                            pageNum: HKConstants.VRS.RES.MESSEAGE_LIST_NUMBER_FOR_TOP,
                            page: COMMON_CONSTANTS.FIRST_PAGE,
                        },
                        [
                            new SortOrder('topFixed', 'desc'),
                            new SortOrder('publishStartDate', 'desc'),
                            new SortOrder('updateDatetime', 'desc'),
                        ]), this.props.navigate)

            if (messageList && messageList.details !== null) {
                this.setState({messageList: messageList.details.messageInfo})
            }

            if (judgeAuthorityCheck(HKConstants.CMN.AUTH.VIEW_FACILITY_RESERVE)) {
                if (condominiumCd) {
                    const reservationsOfWaitingConfirmation = await NatAsyncCallFunction(
                        this.props.reservationsRepo.getReservationsOfWaitingConfirmation.bind(
                            this.props.reservationsRepo,
                            condominiumCd,
                        ),
                        this.props.navigate,
                    )

                    let waitingFlag: boolean = false
                    if (reservationsOfWaitingConfirmation !== null &&
                        reservationsOfWaitingConfirmation.facilityReserveConfirmLimit !== null &&
                        reservationsOfWaitingConfirmation.reservationCardInformations.length > 0) {
                        waitingFlag = true
                        this.setState({
                            waitingFlag: waitingFlag,
                            facilityReserveConfirmLimit:
                            reservationsOfWaitingConfirmation.facilityReserveConfirmLimit.label,
                        })
                    }

                    const reservationCardInformations = await NatAsyncCallFunction(
                        this.props.facilityReserveRepo.getFutureReservationsLimit.bind(
                            this.props.facilityReserveRepo,
                            condominiumCd,
                            Number(HKConstants.VRS.RES.RESERVE_LIST_NUMBER_FOR_TOP),
                        ),
                        this.props.navigate,
                    )

                    if (reservationCardInformations && reservationCardInformations.length > 0) {
                        this.setState({
                            reservationCardInformations: reservationCardInformations,
                        })
                    } else if (!waitingFlag) {
                        this.setState({
                            reserveNoneFlag: true,
                        })
                    }
                }

                this.setState({
                    userReservationListLinkTxt: (judgeAuthorityCheck(HKConstants.CMN.AUTH.EDIT_FACILITY_RESERVE) ?
                        '一覧を見る(変更・キャンセル)' : '一覧を見る'),
                })
            }

            if (condominiumCd) {
                // 申請履歴取得
                const applyHistoryList: Nullable<NatGetApplyHistoryList> =
                    await NatAsyncCallFunction(
                        this.props.applicationRepo.getApplyHistoryList.bind(
                            this.props.applicationRepo,
                            condominiumCd,
                            searchConditionDate),
                        this.props.navigate)
                if (applyHistoryList && applyHistoryList.details !== null) {
                    this.setState({applyHistoryList: applyHistoryList.details.applyInfo})
                }
            }

            const isSutekiNetSmartPhoneApplication = SessionStorageHelper
                .getStringItemWithDefault('isSutekiNetSmartPhoneApplication', 'false')

            if (isSutekiNetSmartPhoneApplication === 'true') {
                const campaignList: Nullable<NatGetCampaign> =
                    await NatAsyncCallFunction(
                        this.props.campaignRepo.getCampaignBanner.bind(
                            this.props.campaignRepo), this.props.navigate)
                if (campaignList?.details?.campaignInfos[0]) {
                    this.setState({
                        campaignInfo: {
                            campaignUrl: campaignList.details.campaignInfos[0].campaignUrl,
                            campaignImagePath: campaignList.details.campaignInfos[0].campaignImagePath,
                        },
                    })
                }
            }

            // 住まいレージポイントの処理
            const smileagePoint: Nullable<NatGetSmileagePoint> = await smileagePointPromise
            if (smileagePoint === null) {
                return
            }
            this.setState({
                getSmileagePointResponse: smileagePoint.details,
            })

            const sutekiNetPlus: Nullable<NatGetSutekiNetPlus> =
                await NatAsyncCallFunction(
                    this.props.sutekiNetPlusRepo.getSutekiNetPlus.bind(
                        this.props.sutekiNetPlusRepo), this.props.navigate)

            if (!sutekiNetPlus?.details) {
                return;
            }

            this.setState({
                sutekiNetPlusUrlPc: sutekiNetPlus.details.sutekiNetPlusUrlPc,
                sutekiNetPlusUrlSp: sutekiNetPlus.details.sutekiNetPlusUrlSp,
            })

            const apartViewFlag: boolean =
                judgeAuthorityCheck(HKConstants.CMN.AUTH.VIEW_APART_ASSOC_INFO) ||
                judgeAuthorityCheck(HKConstants.CMN.AUTH.VIEW_APART_INFO)

            const assocViewFlag: boolean =
                judgeAuthorityCheck(HKConstants.CMN.AUTH.VIEW_APART_ASSOC_INFO) ||
                judgeAuthorityCheck(HKConstants.CMN.AUTH.VIEW_ASSOC_INFO)

            const applyStatusViewFlag = judgeHaveAnyOneOfAuthorities(
                HKConstants.CMN.AUTH.APPLY_CONTACT_ADDRESS_EMERGENCY,
                HKConstants.CMN.AUTH.APPLY_PARKING_USE_APPLICATION,
                HKConstants.CMN.AUTH.APPLY_PARKING_WITHDRAWAL_APPLICATION,
                HKConstants.CMN.AUTH.APPLY_CAR_CHANGE_NOTIFICATION,
                HKConstants.CMN.AUTH.APPLY_BICYCLE_PARKING_USE_APPLICATION,
                HKConstants.CMN.AUTH.APPLY_BICYCLE_PARKING_WITHDRAWAL_APPLICATION,
                HKConstants.CMN.AUTH.APPLY_BIKE_PARKING_USE_APPLICATION,
                HKConstants.CMN.AUTH.APPLY_BIKE_PARKING_WITHDRAWAL_APPLICATION,
                HKConstants.CMN.AUTH.APPLY_BIKE_CHANGE_NOTIFICATION,
                HKConstants.CMN.AUTH.APPLY_PET_BREEDING_APPLICATION,
                HKConstants.CMN.AUTH.APPLY_PET_MEDICAL_CHECK_UP_REPORT,
                HKConstants.CMN.AUTH.APPLY_PET_BREEDING_STOP,
                HKConstants.CMN.AUTH.APPLY_CONSTRUCTION_APPLICATION,
                HKConstants.CMN.AUTH.APPLY_CONSTRUCTION_COMPLETE_NOTIFICATION,
                HKConstants.CMN.AUTH.APPLY_WINDOW_GLASS_FILM_PASTE_NOTIFICATION,
                HKConstants.CMN.AUTH.APPLY_LONG_TERM_ABSENCE_NOTIFICATION,
                HKConstants.CMN.AUTH.APPLY_HEAVY_LOADS_CARRY_IN_NOTIFICATION,
                HKConstants.CMN.AUTH.APPLY_BROWSE_APPLICATION,
            )

            this.setState({
                apartViewFlag: apartViewFlag,
                assocViewFlag: assocViewFlag,
                applyStatusViewFlag: applyStatusViewFlag,
                loginMode: loginMode,
            })

        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    // 請求額確定通知取得
    async getNotifiedAmountFix(condominiumCd: string): Promise<Nullable<NatGetBillingAmountFixInfo>> {
        const ridgeCd = SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_RIDGE_CD);
        const roomNumber = SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_ROOM_NUMBER);
        if (condominiumCd && ridgeCd && roomNumber &&
            judgeAuthorityCheck(HKConstants.CMN.AUTH.VIEW_BILLING_AMOUNT)
        ) {
            const seq: Nullable<number> = await this.getSelectedSeq(condominiumCd, ridgeCd, roomNumber)
            if (seq) {
                return await NatAsyncCallFunction(
                    this.props.amountFixRepo.getBillingAmountFixInfo.bind(
                        this.props.amountFixRepo, condominiumCd, ridgeCd, roomNumber, seq), this.props.navigate
                )
            }
        }
        return null;
    }

    // 連番取得
    async getSelectedSeq(condominiumCd: string, ridgeCd: string, roomNumber: string): Promise<Nullable<number>> {
        const residentUserInvolvingSubResponse: NatGetResidentUserInvolvingSub | null =
            await NatAsyncCallFunction(
                this.props.residentUserRepo.getResidentUserInvolvingSub.bind(
                    this.props.residentUserRepo, condominiumCd, ridgeCd, roomNumber), this.props.navigate)
        const loginUserId = SessionStorageHelper.getStringItemOrNull(KEY_USER_ID);
        if (residentUserInvolvingSubResponse?.details) {
            const mainUser = residentUserInvolvingSubResponse.details.mainUser
            const subUsers = residentUserInvolvingSubResponse.details.subUser
            if (mainUser.userId === loginUserId) {
                return mainUser.seq;
            } else {
                const targetSubUser = subUsers.find(subUser => subUser.userId === loginUserId)
                if (targetSubUser) {
                    return targetSubUser.seq;
                }
            }
        }
        return null;
    }

    // 管理者操作不可メッセージダイアログ
    private renderOperationNotAvailableToAdminDialog(): ReactNode {
        return (
            <MessageDialogComponent
                open={this.state.openOperationNotAvailableToAdminDialog}
                params={{
                    title: '確認',
                    errorLevel: Messages.ISYCR0001.errorLevel,
                    message: Messages.ISYCR0001.toString(),
                    buttonProps: [
                        {
                            isDefault: false,
                            buttonLabel: 'OK',
                            buttonHandler: this.handleCloseOperationNotAvailableToAdminDialog,
                        },
                    ],
                }}
            />
        )
    }

    // 管理者捜査不可メッセージダイアログを閉じる
    handleCloseOperationNotAvailableToAdminDialog = () => {
        this.setState({openOperationNotAvailableToAdminDialog: false})
    }

    onClickBanner(): void {
        // ログインしているユーザのロールが管理者かどうか判定
        if (this.state.loginMode === LOGIN_MODE.ADMIN.value) {
            this.setState({openOperationNotAvailableToAdminDialog: true})
        } else {
            window.open(this.state.campaignInfo.campaignUrl)
        }
    }

    renderCampaignBanner(): ReactElement {
        if (!this.state.campaignInfo.campaignUrl || !this.state.campaignInfo.campaignImagePath) {
            return (<></>)
        }
        return (
            <>
                <CampaignImage
                    onClick={this.onClickBanner}
                    src={(this.state.campaignInfo.campaignImagePath)}
                    alt={'キャンペーンバナー'}>
                </CampaignImage>
                <BlockSpacer height={'15px'}/>
            </>
        )
    }

    getMessageListElement(): ReactElement {
        if (this.state.messageList !== undefined &&
            this.state.messageList.length > 0) {
            return (
                <>
                    <MessageList>
                        {this.state.messageList.map((messageInfo) => (
                            <NatResidentMessageListItemComponent
                                onClick={() => this.onClickMessage(messageInfo.messageId)}
                                messageInfo={messageInfo}/>
                        ))}
                    </MessageList>
                    <SpButton>
                        <BlockSpacer height={'20px'}/>
                        <SecondaryButton onClick={this.handleBackButtonClick}>一覧を見る</SecondaryButton>
                    </SpButton>
                </>
            )
        } else {
            return (
                <NoText>メッセージはありません</NoText>
            )
        }

    }

    getFacilityReserveListElement(): ReactElement {
        if (this.state.reserveNoneFlag) {
            return (
                <NoText>予約はありません</NoText>
            )
        }

        return (
            <>
                {this.state.waitingFlag &&
                    <Box pb={'15px'}>
                        <WaitingConfirmation>
                            <WaitingConfirmationTxt>
                                確定待ちの予約があります。{this.state.facilityReserveConfirmLimit}日までに確定してください。
                            </WaitingConfirmationTxt>
                            <Box pt={'15px'}>
                                <SmallPlainLink
                                    to={`/resident/condominiums/${SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_CONDOMINIUM_CD)}/my-reservations`}>
                                    予約一覧から確定する ＞
                                </SmallPlainLink>
                            </Box>
                        </WaitingConfirmation>
                    </Box>
                }
                {
                    (this.state.reservationCardInformations !== undefined &&
                        this.state.reservationCardInformations.length > 0)
                        ?
                        <>
                            <Box pb={'15px'}>
                                <AnnotationStyle>
                                    確定済みの施設（ご利用日の近い{HKConstants.VRS.RES.RESERVE_LIST_NUMBER_FOR_TOP}件を表示）
                                </AnnotationStyle>
                            </Box>
                            {this.state.reservationCardInformations.map((messageList, index) => (
                                <div key={index}>
                                    {this.getFacilityReserveListDetail(messageList)}
                                </div>
                            ))}
                            <SpButton>
                                <SecondaryButton onClick={this.handleReserveListButtonClick}>
                                    {this.state.userReservationListLinkTxt}
                                </SecondaryButton>
                            </SpButton>
                        </>
                        :
                        <>
                            <NoText>確定した予約はありません</NoText>
                        </>
                }
            </>
        )

    }

    getFacilityReserveListDetail(reservationCardInformations: ReservationStatusCardInformation):
        ReactElement {

        let useDurationString: string
        if (reservationCardInformations instanceof ReservationCardInformation) {
            const useStartDatetimeString = reservationCardInformations.reserveStartDatetime.format('YYYY.MM.DD HH:mm')
            let useEndDatetimeString: string
            if (reservationCardInformations.reserveStartDatetime.format('YYYY-MM-DD') ===
                reservationCardInformations.reserveEndDatetime.format('YYYY-MM-DD')) {
                useEndDatetimeString = reservationCardInformations.reserveEndDatetime.format('HH:mm')
            } else {
                useEndDatetimeString = reservationCardInformations.reserveEndDatetime.format('YYYY.MM.DD HH:mm')
            }
            useDurationString = `${useStartDatetimeString} ～ ${useEndDatetimeString}`

        } else {
            useDurationString = `${reservationCardInformations.useDate.format('M月D日(ddd)')}`
        }

        return (
            <Box pb={'15px'}>
                <ElectionnReserveContainer>
                    <ReserveDetailContainer>
                        <ReserveDetailDate>{useDurationString}</ReserveDetailDate>
                        <ReserveDetailFacility>{reservationCardInformations.facilityName}</ReserveDetailFacility>
                    </ReserveDetailContainer>
                </ElectionnReserveContainer>
            </Box>

        )
    }

    getApplyCategoryLabel(applyCategory: string): ReactElement {
        const applyCategoryLabel = APPLY_CATEGORY.codeToEnumConstants(applyCategory)
        if (applyCategoryLabel) {
            return (
                <div>{applyCategoryLabel.label}</div>
            )
        } else {
            return (
                <div></div>
            )
        }
    }

    getApplyStatusLabel(applyStatus: string): ReactElement {
        if (convertApplyStatusIntoApplyHistoryDivision(applyStatus)) {
            return (
                <div>{convertApplyStatusIntoApplyHistoryDivision(applyStatus).label}</div>
            )
        } else {
            return (
                <div></div>
            )
        }
    }

    getApplyHistoryListElement(): ReactElement {
        if (this.state.applyHistoryList !== undefined &&
            this.state.applyHistoryList.length > 0) {
            const topApplyHistory = this.state.applyHistoryList.slice(0, 3)
            return (
                <>
                    <Box pb={'15px'}>
                        <AnnotationStyle>
                            3か月以内に提出した申請のうち、提出日の近い{HKConstants.VRS.RES.APPLY_HISTORY_LIST_NUMBER_FOR_TOP}件を表示
                        </AnnotationStyle>
                    </Box>
                    <ApplyCategoryTable>
                        {topApplyHistory.map((applyHistoryLists, index) => (
                            <ApplyCategoryTr key={index}>
                                <ApplyStatusLabel applyStatus={applyHistoryLists.applyStatus}>
                                    {this.getApplyStatusLabel(applyHistoryLists.applyStatus)}
                                </ApplyStatusLabel>
                                <ApplyCategoryLabel>
                                    {this.getApplyCategoryLabel(applyHistoryLists.applyCategory)}
                                </ApplyCategoryLabel>
                            </ApplyCategoryTr>
                        ))}
                    </ApplyCategoryTable>
                    <SpButton>
                        <SecondaryButton onClick={this.handleHistoryBackButtonClick}>申請履歴を見る</SecondaryButton>
                    </SpButton>
                </>
            )
        } else {
            return (
                <NoText>申請はありません</NoText>
            )
        }
    }

    // 物件画像を表示用に成形
    getCondominiumuImage(): Nullable<ReactElement> {
        if (!this.state.condominiumuImagePath) {
            return null
        }
        return (
            <CondominuimImfWrapper>
                <CondominuimImg src={`${this.state.condominiumuImagePath}?${new Date().getTime()}`} alt="物件画像"/>
            </CondominuimImfWrapper>
        )
    }

    // 郵便番号を表示用に成形
    getPostalCodeText(): string {
        const zipCode: string | null = window.sessionStorage.getItem(KEY_SELECTED_CONDOMINIUM_ZIP_CODE)
        if (!zipCode) {
            return ''
        }
        return '〒' + zipCode.substr(0, 3) + '-' + zipCode.substr(-4, 4)
    }

    getRegistrationDialogComponent(): ReactElement | null {
        return (
            <NatRegistrationDialogComponent
                open={this.state.dialogOpen}
                handleCancelSetting={this.handleCancelSetting}
                navigate={this.props.navigate}
            />
        )
    }

    onClickMessage(messageId: string): void {
        this.props.navigate(`/resident/message/${messageId}`, {state: {previousPageUrl: '/resident/mypage'}})
    }

    handleCancelSetting(): void {
        this.setState({dialogOpen: false})
    }

    handleBackButtonClick(): void {
        this.props.navigate(`/resident/messageList`)
    }

    handleHistoryBackButtonClick(): void {
        const condominiumCd = SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_CONDOMINIUM_CD)
        this.props.navigate(`/resident/condominiums/${condominiumCd}/applications/history`)
    }

    handleReserveListButtonClick(): void {
        this.props.navigate(`/resident/condominiums/${SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_CONDOMINIUM_CD)}/my-reservations`)
    }

    renderAssocAttention(to: string, message: string): ReactNode {
        return <MeetingAttentionLink
            to={to}>
            <BlueInfoIcon/>
            {message}
        </MeetingAttentionLink>
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        const condominiumCd = SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_CONDOMINIUM_CD)

        return (
            <MyPageArea>
                {this.renderOperationNotAvailableToAdminDialog()}
                <NotificationListArea>
                    {
                        this.state.showBeforeOccupancyMessage &&
                        <NotificationListItem>
                            <BeforeOccupancyMessageArea>
                                <Box height={'21px'} display={'flex'} alignItems={'center'}>
                                    <BlueInfoIcon/>
                                </Box>
                                <Box width={'5px'} minWidth={'5px'}/>
                                現在、上記メニューのみがご利用可能です。ご入居後には、すべてのメニューがご利用可能となります。
                            </BeforeOccupancyMessageArea>
                        </NotificationListItem>
                    }
                    {
                        this.state.showMeetingAttention &&
                        <NotificationListItem>
                            {this.renderAssocAttention(
                                `/resident/condominiums/${condominiumCd}/assoc-top`,
                                '本日は理事会があります',
                            )}
                        </NotificationListItem>
                    }
                    {
                        this.state.showMeetingNeedsAttendanceReplyAttention &&
                        <NotificationListItem>
                            {this.renderAssocAttention(
                                `/resident/condominiums/${condominiumCd}/assoc-top`,
                                '理事会の出欠回答依頼が届いています',
                            )}
                        </NotificationListItem>
                    }
                    {
                        this.state.notNotifiedAmountFixYearMonth &&
                        <NotificationListItem>
                            {this.renderAssocAttention(
                                `/resident/condominiums/${condominiumCd}/billingAmountConfirm`,
                                moment(this.state.notNotifiedAmountFixYearMonth).format('YYYY年M月') +
                                '分のご請求金額が確認できます'
                            )}
                        </NotificationListItem>
                    }
                    {
                        this.state.residentGeneralMeetingInfoList.map(generalMeetingInfo => (
                            <NotificationListItem>
                                {this.renderAssocAttention(
                                    `/resident/condominiums/${condominiumCd}/general-meetings/${generalMeetingInfo.generalMeetingId}`,
                                    `${generalMeetingInfo.generalMeetingName}の意思表明の回答依頼が届いています`
                                )}
                            </NotificationListItem>
                        ))
                    }
                </NotificationListArea>

                <div style={{display: 'flex'}}>
                {this.state.getSmileagePointResponse.showSmileagePointArea &&
                    <Box pb={`15px`} width={'100%'} >
                        <NatSmileagePointComponent
                            getSmileagePointResponse={this.state.getSmileagePointResponse}
                            loginMode={this.state.loginMode}
                            navigate={this.props.navigate}
                        />
                    </Box>
                }
                <Box pb={`15px`}>
                    <NatSutekiNetPlusComponent
                        sutekiNetPlusUrlPc={this.state.sutekiNetPlusUrlPc}
                        sutekiNetPlusUrlSp={this.state.sutekiNetPlusUrlSp}
                        loginMode={this.state.loginMode}
                        navigate={this.props.navigate}
                        showSmileagePointArea={this.state.getSmileagePointResponse.showSmileagePointArea}
                    />
                </Box>
                </div>
                {this.renderCampaignBanner()}

                <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.VIEW_MESSAGE}>
                    <Box pb={`15px`}>
                        <MainContainer>
                            <>
                                <ContentsMainTitleBorder>メッセージ</ContentsMainTitleBorder>
                                {this.state.messageList !== undefined && this.state.messageList.length > 0 &&
                                    <PcLink>
                                        <SmallPlainLink to={'/resident/messageList'}>
                                            一覧を見る
                                        </SmallPlainLink>
                                    </PcLink>
                                }

                            </>
                            <Box pt={`15px`}>
                                {this.getMessageListElement()}
                            </Box>
                        </MainContainer>
                    </Box>
                </AuthorityChecker>
                <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.VIEW_FACILITY_RESERVE}>
                    <Box pb={`15px`}>
                        <MainContainer>
                            <ContentsMainTitleBorder>施設予約状況</ContentsMainTitleBorder>
                            {this.state.messageList !== undefined &&
                                this.state.messageList.length > 0 &&
                                !this.state.reserveNoneFlag &&
                                <PcLink>
                                    <SmallPlainLink to={`/resident/condominiums/${condominiumCd}/my-reservations`}>
                                        {this.state.userReservationListLinkTxt}
                                    </SmallPlainLink>
                                </PcLink>
                            }
                            <Box pt={`15px`}>
                                {this.getFacilityReserveListElement()}
                            </Box>
                        </MainContainer>
                    </Box>
                </AuthorityChecker>
                {this.state.applyStatusViewFlag &&
                    <Box pb={`15px`}>
                        <MainContainer>
                            <ContentsMainTitleBorder>申請状況</ContentsMainTitleBorder>
                            {this.state.applyHistoryList !== undefined &&
                                this.state.applyHistoryList.length > 0 &&
                                <PcLink>
                                    <SmallPlainLink
                                        to={`/resident/condominiums/${condominiumCd}/applications/history`}>
                                        申請履歴を見る
                                    </SmallPlainLink>
                                </PcLink>
                            }
                            <Box pt={`15px`}>
                                {this.getApplyHistoryListElement()}
                            </Box>
                        </MainContainer>
                    </Box>
                }
                <MainContainer>
                    <Box pb={`15px`}>
                        {this.getCondominiumuImage()}
                        <CondominuimWrapper>
                            <TxtBold>{SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_CONDOMINIUM_NAME)}</TxtBold>
                            <CondominuimWrapper>
                                {this.getPostalCodeText()}
                                <CondominumAddressBlock>
                                    {SessionStorageHelper.getStringItemOrNull(
                                        KEY_SELECTED_CONDOMINIUM_ADDRESS_PREFECTURE)}
                                    {SessionStorageHelper.getStringItemOrNull(
                                        KEY_SELECTED_CONDOMINIUM_ADDRESS_ADDRESS2)}
                                    {SessionStorageHelper.getStringItemOrNull(
                                        KEY_SELECTED_CONDOMINIUM_ADDRESS_ADDRESS3)}
                                </CondominumAddressBlock>
                                <PcApartAssocBlock>
                                    <PcApartAssocDisplayInlineBlock
                                        condominiumuImagePath={this.state.condominiumuImagePath}>
                                        {this.state.apartViewFlag &&
                                            <PcApartAssocLinkPadding to={'/resident/apartInfoList'}>
                                                マンション情報
                                            </PcApartAssocLinkPadding>
                                        }

                                        {this.state.assocViewFlag &&
                                            <SmallPlainLink to={'/resident/assocInfoList'}>
                                                組合情報
                                            </SmallPlainLink>
                                        }
                                    </PcApartAssocDisplayInlineBlock>
                                </PcApartAssocBlock>
                            </CondominuimWrapper>
                        </CondominuimWrapper>
                    </Box>
                    <ApartAssocUl>
                        {this.state.apartViewFlag &&
                            <ApartAssocli>
                                <SmallPlainLink to={'/resident/apartInfoList'}>
                                    マンション情報
                                </SmallPlainLink>
                            </ApartAssocli>
                        }
                        {this.state.assocViewFlag &&
                            <ApartAssocli>
                                <SmallPlainLink to={'/resident/assocInfoList'}>
                                    組合情報
                                </SmallPlainLink>
                            </ApartAssocli>
                        }
                    </ApartAssocUl>
                </MainContainer>
                {this.getRegistrationDialogComponent()}
            </MyPageArea>
        )
    }
}

export default createResidentPage(NatResidentMypagePage)

// ブレイクポイント
const breakPoint: any = generateMedia({
    sp: `${BreakPoint.Sp}`,
})

/*
    sp版の場合、メニューの周りが15pxのpaddingで囲まれており、
    このコンポーネント(NatResidentMypagePage)の親のResidentContentsAreaComponentの15pxのpaddingと合わせて、
    上に30pxの余白が出てきてしまっている
    影響範囲を抑えるつつ、この問題に対応するためsp版の場合-15pxのmarginで調整する
 */
const MyPageArea = styled.div`
    ${breakPoint.lessThan('sp')`
        margin-top: -15px;
  `}
`

const NotificationListArea = styled.div`
`

const NotificationListItem = styled.div`
  margin-bottom: 5px;
  overflow-wrap: anywhere;
  line-break: anywhere;

  :last-child {
    margin-bottom: 15px;
  }
`

const PcLink: StyledDiv = styled.div`
    display: inline-block;
    float: right;

    ${breakPoint.lessThan('sp')`
    display: none;
  `}
`

const SpButton: StyledDiv = styled.div`
    display: none;

    ${breakPoint.lessThan('sp')`
    display: block;
    padding-bottom: 5px;
  `}
`

const AnnotationStyle: StyledDiv = styled.div`
    font-size: 14px;
`

const MessageList: StyledDiv = styled.div`
    margin-top: 5px;
    margin-left: -15px;
    margin-right: -15px;
`

const ApplyCategoryTd: StyledDiv = styled.div`
    display: table-cell;
    vertical-align: inherit;
    padding-right: 10px;
    padding-left: 10px;
    word-break: break-all;

    ${breakPoint.lessThan('sp')`
  display: block;
  padding-right: 10;
  padding-left: 10;
`}
`

const ApplyCategoryLabel = styled(ApplyCategoryTd)`
    width: 242px;
    font-weight: ${FontWeights.Bold};
`

interface ApplyHistoryCssParams {
    applyStatus: string
}

const applyStatusColor = (props: ApplyHistoryCssParams) => {
    if (props.applyStatus === RESIDENT_APPLY_STATUS.COMPLETE.value) {
        return `background: linear-gradient(166deg, #009188 50%, #00838A 50%);`
    } else if (props.applyStatus === RESIDENT_APPLY_STATUS.REJECTION.value) {
        return `background: #707070;`
    } else {
        return 'background: linear-gradient(166deg, #E76608 50%, #CF5A00 50%);'
    }
}

const ApplyStatusLabel = styled.div<ApplyHistoryCssParams>`
    color: #fff;
    text-align: center;
    font-size: ${FontSize.Small};
    vertical-align: inherit;
    width: 48px;
    height: 18px;
    padding: 1px 7px 1px 7px;

    ${(props: ApplyHistoryCssParams) => applyStatusColor(props)}

    ${breakPoint.lessThan('sp')`
   vertical-align: text-top;
`}
`
const ApplyCategoryTable: StyledDiv = styled.div`
    display: table;
    border-collapse: separate;
    border-spacing: 2px;
    border-color: grey;
`

const ApplyCategoryTr: StyledDiv = styled.div`
    display: flex;
    padding: 0px 0px 15px 0px;
    align-items: center;
`

const NoText: StyledDiv = styled.div`
    text-align: center;
    color: ${Colors.Body};
`

const CondominumAddressBlock: StyledDiv = styled.div`
    display: inline-block;
    padding-left: 15px;


    ${breakPoint.lessThan('sp')`
    display: block;
    padding-left: 0;
  `}
`

const CondominuimImg: StyledImg = styled.img`
    height: 10rem;
    max-width: 10rem;
    box-shadow: 2px 2px 4px ${Colors.AccentDark};
`

const CondominuimWrapper: StyledDiv = styled.div`
    overflow: hidden;
    zoom: 1;
`

const CondominuimImfWrapper: StyledDiv = styled.div`
    overflow: hidden;
    zoom: 1;
    float: left;
    margin: 0 10px 5px 0;
`

const PcApartAssocBlock: StyledDiv = styled.div`
    padding-top: 15px;

    ${breakPoint.lessThan('sp')`
     display: none;
  `}
`

const PcApartAssocDisplayInlineBlock = styled.div<{ condominiumuImagePath: Nullable<string> }>`
  ${props => {
    if (props.condominiumuImagePath) {
        return css`
        display: inline-block;
      `
    }
}}
`

const PcApartAssocLinkPadding = styled(SmallPlainLink)`
    padding-right: 15px;
`

const ApartAssocUl: StyledUl = styled.ul`
    display: none;

    ${breakPoint.lessThan('sp')`
    display: block;
    margin: 0;
    padding: 30px 0 30px 0;
    text-align: center;
    li + li {
      border-left: 1px solid #333;
    }
  `}
`

const ApartAssocli: StyledLi = styled.li`
    display: inline-block;
    width: 50%;
    box-sizing: border-box;
`

const WaitingConfirmation: StyledDiv = styled.div`
    padding: 15px;
    background-color: rgba(239, 106, 11, 0.05);
    text-align: center;

`

const ElectionnReserveContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: baseline;
    width: 100%;

    color: ${Colors.Body};
    background-color: ${Colors.Surface};
    line-height: 21px;
    font-weight: ${FontWeights.Normal};

    &::before {
        content: "";
        background: linear-gradient(166deg, rgb(0, 145, 136) 50%, #00838a 50%);
        height: 12px;
        width: 12px;
        display: inline-block;
        margin: 0 10px;
    }
`

const ReserveDetailContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;

    ${breakPoint.lessThan('sp')`
     flex-direction: column;
  `}
`

const ReserveDetailDate = styled.div`
    padding-right: 15px;
    flex-basis: 300px;

    ${breakPoint.lessThan('sp')`
     flex-basis: auto;
  `}
`

const ReserveDetailFacility = styled.div`
    font-weight: ${FontWeights.Bold};
    text-align: left;
    flex: 1 0 0%;

    ${breakPoint.lessThan('sp')`
    flex: 0 1 auto;
  `}
`

const WaitingConfirmationTxt = styled.div`
    text-align: center;
`

const AttentionMessageAreaStyle = css`
    width: 100%;
    font-size: ${FontSize.Middle};
    font-weight: ${FontWeights.Normal};
    background: rgb(242, 248, 251);
`

const BeforeOccupancyMessageArea = styled.div`
    ${AttentionMessageAreaStyle};
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    padding: 4.5px 10px;
`

const MeetingAttentionLink = styled(UnstyledLink)`
    ${AttentionMessageAreaStyle};
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 5px 10px 5px 10px;
    box-sizing: border-box;
    gap: 5px;

    &::after {
        content: '';
        min-width: 0.8rem;
        height: 0.8rem;
        border-top: solid 2px ${Colors.AccentDark};
        border-right: solid 2px ${Colors.AccentDark};
        -webkit-transform: rotate(45deg);
        transform: rotate(45deg);
        margin-left: auto;
        margin-right: 0.16rem;
    }
`
const CampaignImage = styled.img`
    box-sizing: border-box;
    width: 100%;
    vertical-align: middle;
`
